module.exports = __webpack_public_path__ + "static/media/cliente-via-seeds.d5a6bc9f.webp";